;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);
	var scrolledY = 0;
	var $spinner = $('.loading-screen');

	var isLoading   = false;
	var noMorePosts = false;

	// Load AJAX data
	function loadAjax(filePath) {
		return $.ajax({
			'async': false,
			'global': false,
			'url': filePath
		}).responseJSON;
	}

	google.maps.Map.prototype.setCenterWithOffset= function(latlng, offsetX, offsetY) {
		var map = this;
		var ov = new google.maps.OverlayView();
		ov.onAdd = function() {
			var proj = this.getProjection();
			var aPoint = proj.fromLatLngToContainerPixel(latlng);
			aPoint.x = aPoint.x+offsetX;
			aPoint.y = aPoint.y+offsetY;
			map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
		};
		ov.draw = function() {};
		ov.setMap(this);
	};

	function initMap( url ) {
		if ( $( '#map' ).length === 0 ) {
			return;
		}

		var params = getQueryParams( url );
		var page = $( '.current-page' ).data( 'page' );
		var endpointLink = crb_theme_data.events_endpoint;
		if ( params ) {
			endpointLink += '&' + params;
		}

		$.ajax( {
			method: 'GET',
			url: endpointLink,
			data: {
				page: page
			},
			beforeSend: function () {
				isLoading = true;

				$('body').addClass( 'loading' );
			},
		})
		.done( function( json ) {
			updateMarkers( json );
		})
		.complete( function() {
			isLoading = false;

			$('body').removeClass( 'loading' );
		});
	}

	google.maps.event.addDomListener(window, 'load', function() {
		initMap( window.location.href );
	});

	function getQueryParams( url ) {
		if ( url.indexOf('?') === -1 ) {
			return '';
		}

		return url.slice(url.indexOf('?') + 1);
	}

	function getCurrentPageURL() {
		return window.location.href.split("?")[0];
	}

	function updateMarkers( mapMarkers ) {
		var $map = $('#map');
		var mapData = {
			"cluster" : true,
			"mapOptions": {
				"center": {
					"lat": 32.0310528,
					"lng": -87.0754335
				},
				"zoom": 5,
				"minZoom": 4,
				"mapTypeControl": false,
				"styles": [
					{"featureType":"all","elementType":"all","stylers":[{"saturation":-100}]}
				]
			},
		};

		var map = new google.maps.Map($map.get(0), mapData.mapOptions);

		if ( mapMarkers.length <= 0 ) {
			map.setZoom( 4 );
			return;
		}

		var markers = [];
		var markersLength = mapMarkers.length;
		var content;
		var markerCluster;
		var bounds = new google.maps.LatLngBounds();

		for (var i = 0; i < markersLength; i++) {

			var marker;

			marker = new google.maps.Marker({
				position: new google.maps.LatLng(mapMarkers[i].position),
				map: map,
				icon: mapMarkers[i].icon
			});

			markers.push(marker);
			bounds.extend(marker.position);
		}

		map.fitBounds(bounds);
	}

	$( 'form.events-filter-from' ).on( 'submit', function(e) {
		e.preventDefault();

		var link = getCurrentPageURL( window.location.href ) + '?' + $(this).serialize();

		loadMorePosts( link, true );
		initMap( link );
	} );


	//Animate Sections
	var $animated = $('.animated');

	var winHeight = $win.height();
	var winWidth = $win.width();
	var winScroll = $win.scrollTop();

	function animateElements() {
		winScroll = $win.scrollTop();

		if ( $animated.length === 0 ) {
			return;
		}
	};


	function animate(winST) {
		$('.animate').each(function(){
			var $this = $(this);

			if (winST + ($win.outerHeight() / 1.3) > $this.offset().top) {
				$this.addClass('animated');
			} else if (winST + ($win.outerHeight() / 2) < $this.offset().top) {
				$this.removeClass('animated');
			}
		});
	}

	$doc.ready(function() {
		initYearRangeSlider();

		$('.btn-burger').on('click', function(e) {
			e.preventDefault();

			$(this).toggleClass('active')
			$('.header').toggleClass('active')
			$('body').toggleClass('active')
		})

		$('.nav a').on('click', function(e){
			if ( $win.width() < 1024 ) {
				var $parent = $(this).parent();
				var $siblingUl = $parent.find(' > ul');

				if ( $siblingUl.length && !$parent.hasClass('open') ){
					$parent.addClass('open').siblings().removeClass('open').find('.open').removeClass('open');

					e.preventDefault();
				}
			};
		})

		$('.js-popup').on( 'click', function( e ) {
			e.preventDefault();

			 $.ajax({
				type: 'GET',
				url: crb_theme_data.ajax_url,
				data: {
					action: 'crb_bio_popup',
					postID: $( this ).data( 'ambassador-id' ),
				},
				success: function( response ){
					$.magnificPopup.open({
						mainClass: 'mfp-fade',
						type: 'inline',
						items: {
							src: response.data
						}
					})
				}
			});
		} );

		$('.js-popup-iframe').magnificPopup({
			type: 'iframe',
			removalDelay: 300,
			mainClass: 'mfp-fade'
		});

		$('.popup-player').on('click', function(e){
			e.preventDefault();

			var link = $(this).attr('href');

			function is_iframe_link(link) {
				var regex = new RegExp('\/ChapelMedia\/');

				return regex.test(link);
			}

			function is_cedarville_video(link) {
				var regex = new RegExp('cedarville\.edu');

				return regex.test(link);
			}

			if ( is_cedarville_video(link) ) {
				if ( ! is_iframe_link(link) ) {
					var result = link.match(/.+\/(.+).*\?y=(.+)$/);
					link = 'https://mediaserve.cedarville.edu/ChapelMedia/Video/Index?id=' + result[1] + '&type=' + result[2];
				}
			}

			$.magnificPopup.open({
				items: {
					src: link,
					type: 'iframe'
				}
			});
		})

		$('.js-toggle').on('click', function(e) {
			e.preventDefault();

			$( $(this).data('target') ).toggleClass( $(this).data('class') )
		})

		//Tabs
		$('body').on('click', '.tabs .tabs__nav a', function(event) {
			var $tabLink = $(this);
			var $targetTab = $($tabLink.attr('href'));

			$tabLink
				.parent()
					.find('.active')
					.removeClass('active')
					.end()
				.addClass('active')
					.siblings()
						.removeClass('active')
						.find('.active')
							.removeClass('active');

			$targetTab.addClass('active').siblings().removeClass('active');

				event.preventDefault();

			$('.slider-teritary .slider__slides').each(function() {
				$(this).slick('refresh')
			})
		});

		//Pannels
		$doc.on('click touchstart', '.tab .tab__head a', function(e) {

			e.preventDefault();

			$(this)
				.closest('.tab')
				.toggleClass('active')
				.siblings()
				.removeClass('active')
		})

		// $('.range-slider').draggable({
		// 	axis: 'x',
		// 	containment: "parent"
		// })

		$('.filter').scrollLock()

		$('body').on('change', '.cases-filter-language', function(e){
			var $selectedLanguage = $(this).find('option:selected');
			var link = getCurrentPageURL( window.location.href ) + '?cfl-language=' + $selectedLanguage.val();

			changeLanguage( link );
		});

		$('.blog-filters').on( 'click', '#btn-clear', function( e ) {
			e.preventDefault();

			clearFilter();
		} );
	});

	$win.on('load', function() {
		animateElements();
		animate(scrolledY);

		$('.slider-primary .slider__slides').slick({
			prevArrow: '#slide-prev',
			nextArrow: '#slide-next',
			adaptiveHeight: true
		})

		$('.slider-secondary .slider__slides').slick()

		$('.slider-articles .slider__slides').slick({
			dots: true,
			arrows: false,
			adaptiveHeight: true
		})

		$('.section-blog .col-inner-primary p > img').each(function(){
			$(this).unwrap();
			$(this).wrap("<div class='section__image'></div>");
		});

		$('.slider-teritary .slider__slides').each(function() {
			$(this).slick({
				slidesToShow: 1,
				dots: true,
				arrows: true,
				customPaging : function(slider, i) {
					var title = $(slider.$slides[i]).find('.slider__slide').data('title');

					return '<a class="pager__item"> '+ title +' </a>';
				},
			})
		})
	}).on('scroll', function() {
		scrolledY = $win.scrollTop();
		animate(scrolledY);
	}).on('load resize', function() {
		if ( $win.width() < 991 ) {
			$('.header .header__body').outerHeight( $win.outerHeight() )
		}
	})

	$('.section--load-more').on( 'click', '.btn-load-more', function(e){
		e.preventDefault();

		if ( isLoading || noMorePosts ) {
			return;
		}

		isLoading = true;
		var nextPageLink = $(this).attr('href');
		loadMorePosts(nextPageLink, false);
	})

	$( 'form.blog-filter-from' ).on( 'submit', function( e ) {
		e.preventDefault();
		console.log('here1');
		var link = getCurrentPageURL( window.location.href ) + '?' + $(this).serialize();
		console.log(link);

		History.pushState({}, null, link );
	} );

	$(window).bind('popstate', function(){
		var $this = $(this);
		if (isLoading) {
			return;
		}

		if ( ! isInternetExplorer() ) {
			var url = $this.context.documentURI;
		} else {
			var url = $this.context.URL;
		}

		loadMorePosts( url, true );
	});

	/**
	 * Detect IE
	 * @returns
	 * true - case: IE/Edge
	 * or
	 * false - case: other Browser
	 */
	function isInternetExplorer() {
		var ua = window.navigator.userAgent;

		var msie = ua.indexOf('MSIE');

		if (msie > 0) {
			return true;
		}

		var trident = ua.indexOf('Trident/');

		if (trident > 0) {
			return true;
		}

		var edge = ua.indexOf('Edge/');

		if (edge > 0) {
			return true;
		}

		// other browser
		return false;
	}

	function clearFilter() {
		var url = stripParams( window.location.href );
		var $form = $( '.blog-filter-from' );
		var $sliderYear = $('#range-slider-year');

		$form.find( 'input[type=checkbox]' ).attr( 'checked', false );

		$sliderYear.slider( 'values', 0, $sliderYear.data( 'min' ) );
		$sliderYear.slider( 'values', 1, $sliderYear.data( 'max' ) );
		$form.find('.range-min').val( $sliderYear.data( 'min' ) );
		$form.find('.range-max').val( $sliderYear.data( 'max' ) );
		$form.find('[name=min-year]').val( $sliderYear.data( 'min' ) );
		$form.find('[name=max-year]').val( $sliderYear.data( 'max' ) );
	}

	/**
	* Remove query string parameter
	*/
	function stripParams( url ) {
		if ( url.indexOf('?') === -1 ) {
			return url;
		}

		return url.split('?')[0];
	}

	function loadMorePosts(nextPageLink, replace) {
		var $sectionLoadMore    = $('.section--load-more');
		var $sectionPostsHolder = $sectionLoadMore.find('.load-more-items');
		var $sectionActions     = $sectionLoadMore.find('.section__actions');

		var nextPageResponse = fetchNextPage(nextPageLink, function(response) {
			if ( response ) {
				var $newSectionLoadMore = $('.section--load-more', response);
				var $newSectionActions  = $newSectionLoadMore.find('.section__actions');
				var $newPosts           = $newSectionLoadMore.find('.load-more-items').children();
				noMorePosts             = false;

				if ( $newSectionActions.find('.btn-load-more').length === 0 ) {
					noMorePosts = true;
				}

				if ( noMorePosts ) {
					$sectionActions.empty();
				} else {
					$sectionActions.replaceWith( $newSectionActions );
				}

				if ( replace ) {
					$sectionPostsHolder.empty().append( $newPosts )
				} else {
					$sectionPostsHolder.append( $newPosts )
				}

				isLoading = false;

				$spinner.toggleClass( 'show' );
			}
		} );
	}

	function changeLanguage(url) {
		var $sectionFilterCases = $('.section--filter-cases');

		var nextPageResponse = fetchNextPage(url, function(response) {
			if ( response ) {
				var $newSectionFilterCases = $('.section--filter-cases', response);

				$sectionFilterCases.empty().append( $newSectionFilterCases )

				isLoading = false;

				$spinner.toggleClass( 'show' );
			}
		} );
	}

	function fetchNextPage(nextPageLink, callback) {
		$.ajax({
			url: nextPageLink,
			type: 'GET',
			beforeSend: function() {
				$spinner.toggleClass( 'show' );
			},
			success: function(response) {
				callback(response);
			},
			error: function() {
				return false;
			}
		});
	}

	function initYearRangeSlider() {
		var $yearRangeSlider = $('#range-slider-year');

		if ( ! $yearRangeSlider.length ) {
			return;
		}

		var priceMin = $yearRangeSlider.data( 'min' );
		var priceMax = $yearRangeSlider.data( 'max' );
		var priceSelectedMin = $yearRangeSlider.data( 'selected-min' );
		var priceSelectedMax = $yearRangeSlider.data( 'selected-max' );

		$yearRangeSlider.slider({
			range: true,
			min: priceMin,
			max: priceMax,
			values: [ priceSelectedMin, priceSelectedMax ],
			slide: function( event, ui ) {
				$('.range-min').css('left', $('.ui-slider-handle')[0].style.left)
				$('.range-min').text( ui.values[0] )

				$('.range-max').css('left', $('.ui-slider-handle')[1].style.left)
				$('.range-max').text( ui.values[1] )

				$('[name=min-year]').val( ui.values[ 0 ] );
				$('[name=max-year]').val( ui.values[ 1 ] );
			},
			stop: function( event, ui ) {
				$('.range-min').css('left', $('.ui-slider-handle')[0].style.left)
				$('.range-min').text( ui.values[0] )

				$('.range-max').css('left', $('.ui-slider-handle')[1].style.left)
				$('.range-max').text( ui.values[1] )

				$('[name=min-year]').val( ui.values[ 0 ] );
				$('[name=max-year]').val( ui.values[ 1 ] );
			}
		});

		// $yearRangeSlider.draggable()
	}
})(jQuery, window, document);
